<template>
  <div class="main-wrap container">
    <!-- action-bar -->
    <action-bar class="head-bar action-bar">
      <div class="left" slot="left">
        <button @click.stop="$router.push('/home/hall')">{{ '购彩大厅' }}</button>
      </div>

      <div class="title" slot="title">
        <span>{{ '开奖结果' }}</span>
      </div>
    </action-bar>

    <div class="v-main">
           <div class="search-wrap">
             <span class="label">彩种：</span>
             <select @change="selectFn" v-model="lottery_type">
              <option :value="l.lottery_type" v-for="l in lotterys" :key="l.id">{{ l.lottery_name }}</option>
             </select>

      <!--        <span>日期：</span>-->
      <!--        <input class="date" type="text" @click="showT" v-model="date"/>-->
      <!--        <div id="demo" v-show="dateShow">-->
      <!--          <inlineCalendar :show="false" @change="onChange"/>-->
      <!--        </div>-->
          </div>
      <div v-for="(item, index) in list" :key="'card'+index" @touchend="onLookDetails(index)">
        <card-item
          class="award-card" :lottery_type="lottery_type"
          :item="item"
          :type="type"
          :isVisible="item.isVisible"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionBar from "@/components/action-bar";
import CardItem from "./card-item";
import { getLotteryResults, getLotteryTypes } from "@/service/lottery";
import objectPath from 'object-path';

export default {
  name: "v-result",
  components: {
    ActionBar,
    CardItem
  },
  data() {
    return {
      lottery_type: 18,
      date: "",
      type: 1,
      list: [],
      lotterys: [],
      results: [],
      dateShow: false
    };
  },
  watch: {
    type: {
      handler(nval) {
        //console.log(nval);
        //this.getAwardsData(nval);
      },
      immediate: true
    }
  },
  mounted() {
    this.created && this.created()
  },
  async created() {
    let query = this.$route.query;
    if (query.lottery_type) {
      this.lottery_type = query.lottery_type;
    }
    var day2 = new Date();
    day2.setTime(day2.getTime());

    var s2 =
      day2.getFullYear() +
      "-" +
      ((day2.getMonth() + 1) < 10 ? "0" + (day2.getMonth() + 1) : (day2.getMonth() + 1)) +
      "-" +
      (day2.getDate() < 10 ? "0" + day2.getDate() : day2.getDate());
    this.date = s2;
    let lotteryTypes = await getLotteryTypes();
    if (lotteryTypes instanceof Promise) {
      lotteryTypes.then((res) => {
        this.lotterys = res.data;
        this.lottery_type = res.data[0].lottery_type;
      })
    } else {
      this.lotterys = lotteryTypes.data;
      this.lottery_type = lotteryTypes.data[0].lottery_type;
    }
    this.change(this.lottery_type, this.date);
  },

  methods: {
    showT() {
      this.dateShow = !this.dateShow;
    },
    onChange(date) {
      this.dateShow = false;
      this.date = date.format("YYYY-MM-DD");
      this.change(this.lottery_type, this.date);
    },

    change(lottery_type, result_date) {
      const vm = this;
      getLotteryResults({
        lottery_type,
        result_date
      }).then(res => {
        const resData = objectPath.get(res, 'data.records') || [];
        //console.log('res ++++', resData);
        vm.list = resData;
      });
      //console.log('res ---', this.list);
    },

    async selectFn(e) {
      this.lottery_type = e.target.value;
      this.lotterys.forEach(item => {
        if (item.lottery_type == this.lottery_type) {
          this.type = item.category;
        }
      });
      this.change(this.lottery_type, this.date);
    },
    onLookDetails(index) {
      let item = this.list[index];
      item.isVisible = item.isVisible ? false : true;
      this.$set(this.list, index, item);
    }
  }
};
</script>

<style scoped lang="less">
.main-wrap {
  font-size: 24px;

  .head-bar {
    z-index: 100;
    position: relative;

    .left {
      width: 140px;

      > button {
        height: 60px;
      }
    }

    .title {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: bold;
      justify-content: center;

      > button {
        width: 50px;
        height: 50px;
        border: 1px solid #b40f06;
        position: relative;
        margin-left: 10px;
        border-radius: 25px;

        &:after {
          top: 22px;
          left: 13px;
          display: block;
          content: "";
          position: absolute;
          border-top: 10px solid #fff;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: none;
          transition: transform 0.2s linear;
        }
      }
    }

    button {
      color: #fff;
      border: 1px solid #b70a00;
      padding: 0 16px;
      position: relative;
      font-size: 24px;
      background: #e8291d;
      background: -webkit-gradient(linear,
      0 0,
      0 70%,
      from(#f94539),
      to(#e8291d));
      box-shadow: 0 2px 2px #fc7f77 inset;
      border-radius: 10px;
    }
  }

  .v-main {
    .search-wrap {
      padding: 15px 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      > select {
        width: 240px;
        height: 44px;
        border: 1px solid #d0d0d0;
      }

      .date {
        height: 44px;
        border: 1px solid #d0d0d0;
        box-sizing: border-box;
        width: 280px;
      }
    }

    #demo {
      position: absolute;
      bottom: 0;
      z-index: 100;
      width: 100%;
    }

    .award-card ~ .award-card {
      margin-top: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/result/index.vue